<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Batch-Status</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div fxLayout="row" class="page-header">
                <span fxFlex></span>
                <mat-form-field fxFlex="40%">
                    <mat-label>Filter</mat-label>
                    <mat-select [(value)]="filter" (selectionChange)="filterData()">
                        <mat-option [value]="null">Alle</mat-option>
                        <mat-option *ngFor="let f of filterOptions" [value]="f.name">{{ f.displayName }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-expansion-panel *ngFor="let job of jobs">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ job.jobExecutionId}}
                        <span class="badge margin-left">{{ job.status }}</span>

                    </mat-panel-title>
                    <mat-panel-description>
                        {{ job.startTime | date:'shortDate' }} {{ job.startTime | date:'mediumTime' }} - {{
                        job.startTime | date:'shortDate' }} {{ job.endTime | date:'mediumTime' }}
                        <span class="badge margin-left">{{ job.jobName }}</span>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <table class="table table-striped" style="table-layout:fixed; word-break: break-all;">
                    <thead>
                        <tr>
                            <th>Verarbeitungsschritt</th>
                            <th>Gelesen</th>
                            <th>Geschrieben</th>
                            <th>Status</th>
                            <th>Start</th>
                            <th>Ende</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let step of job.batchStepExecutions; let isOdd = odd; let isEven = even;">
                            <td width="25%">{{ step.stepName }}</td>
                            <td>
                                {{ step.readCount }}
                            </td>
                            <td>
                                {{ step.writeCount }}
                            </td>
                            <td>
                                <span class="badge">{{ step.status }}</span>
                            </td>
                            <td>
                                {{ job.startTime | date:'shortDate' }} {{ job.startTime | date:'mediumTime' }}
                            </td>
                            <td>
                                {{ job.endTime | date:'shortDate' }} {{ job.startTime | date:'mediumTime' }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Dateistatus</th>
                            <th>Datei</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let step of job.processedFiles; let isOdd = odd; let isEven = even;"
                            class="table-selectable-row" (click)="downloadFile(step.file)">
                            <td>
                                <span class="badge">{{ step.state }}</span>
                            </td>
                            <td>
                                {{ step.file }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Eingangsparameter</th>
                            <th>Wert</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let step of job.batchJobExecutionParams; let isOdd = odd; let isEven = even;">
                            <td>{{ step.keyName }}</td>
                            <td>
                                <span *ngIf="step.typeCd === 'STRING'">{{ step.stringVal }}</span>
                                <span *ngIf="step.typeCd === 'LONG'">{{ step.longVal }}</span>
                                <span *ngIf="step.typeCd === 'DATE'">{{ step.dateVal }}</span>
                                <span *ngIf="step.typeCd === 'DOUBLE'">{{ step.doubleVal }}</span>

                            </td>
                        </tr>
                    </tbody>
                </table>

            </mat-expansion-panel>
            <span *ngIf="this.jobs.length === 0" class="emptyTableState">Keine passenden Einträge
                gefunden</span>

        </div>
    </div>
</div>
<mat-paginator style="margin-top: 25px;" [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size" [pageIndex]="page.number"
    (page)="loadPage($event)" [pageSizeOptions]="[12,24, 36, 48]" *ngIf="page">
</mat-paginator>